import axios from "@/api/axiosInstance";
import { AddPermissionOverrideRequest, AddPermissionOverrideResponse } from "./types";

export const addPermissionOverride = async (
  employeeUuid: string,
  requestData: AddPermissionOverrideRequest,
): Promise<AddPermissionOverrideResponse> => {
  const response = await axios.post<AddPermissionOverrideResponse>(
    `/api/private/admin/employees/${employeeUuid}/permission-overrides`,
    requestData,
  );
  return response.data;
};
